import { useIonAlert } from '@ionic/react';
import { bindAlertPresenter } from './AlertPresenter';

/**
 * This has zero IOC dependencies so it can bind before <AppContainer> and
 * be used to show alerts during app start
 */
export const AlertBinder: React.FC = () => {
    const [showAlert] = useIonAlert();
    bindAlertPresenter(showAlert);
    return null;
};
